<template>
  <v-row>
    <v-col>
      <v-progress-linear v-if="isLoading" color="loader" indeterminate />
      <v-expansion-panels>
        <v-expansion-panel v-test="{ panel: '' }">
          <v-expansion-panel-header>
            <div id="attach_file">
              <v-icon>
                attach_file
              </v-icon>
              {{ $t('Документация по процедуре (действующая редакция)') }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <v-card>
              <documentation-list
                  :documents="currentVersions"
                  :loading="isLoading" />
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-test="{ panel: '' }">
          <v-expansion-panel-header>
            <div id="archive">
              <v-icon>
                archive
              </v-icon>
              {{ $t('Изменения в документации (недействующие редакции)') }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <v-card>
              <documentation-list
                  :documents="previousVersions"
                  :loading="isLoading" />
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-test="{ panel: 'clarifications' }">
          <v-expansion-panel-header>
            <div id="question_answer">
              <v-icon>
                question_answer
              </v-icon>
              {{ $t('Отправить сообщение организатору торгов (продавцу) по процедуре') }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <clarification-list
                :lot="lot"
                :clarifications="clarifications"
                :loading="isLoading"
                @change="getClarificationsList" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>

  import DocumentationList from '@/components/reused/lotDocumentation/DocumentationList.vue'
  import ClarificationList from '@/components/reused/clarification/ClarificationList.vue'
  import { mapActions, mapState } from 'vuex'
  import { LOT_DOCUMENTATION, LOT_CLARIFICATIONS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      DocumentationList,
      ClarificationList
    },
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_DOCUMENTATION.NAMESPACE, {
        documentation: state => (state[LOT_DOCUMENTATION.STATE.LOT_DOCUMENTATION] || {})
      }),
      ...mapState(LOT_CLARIFICATIONS_MANAGEMENT.NAMESPACE, {
        clarifications: state => (state[LOT_CLARIFICATIONS_MANAGEMENT.STATE.CLARIFICATIONS] || [])
      }),
      previousVersions () {
        return this.documentation.previousVersions || []
      },
      currentVersions () {
        return this.documentation.currentVersions || []
      }
    },
    watch: {
      lot: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal.lotId) {
            this.initialize()
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_DOCUMENTATION.NAMESPACE, {
        getLotDocumentationAction: LOT_DOCUMENTATION.ACTIONS.GET_LOT_DOCUMENTATION,
        clearLotDocumentationAction: LOT_DOCUMENTATION.ACTIONS.CLEAR_LOT_DOCUMENTATION
      }),
      ...mapActions(LOT_CLARIFICATIONS_MANAGEMENT.NAMESPACE, {
        getClarificationsListAction: LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.GET_CLARIFICATIONS_LIST,
        clearClarificationsListAction: LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.CLEAR_CLARIFICATIONS_LIST
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearLotDocumentationAction(),
            this.clearClarificationsListAction()
          ])
      },
      initialize: async function () {
        this.isLoading = true
        const model = {
          lotId: this.lot.lotId,
          lotType: this.lot.lotType
        }
        try {
          await Promise.all(
            [
              this.getLotDocumentationAction(model),
              this.getClarificationsListAction(model)
            ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getClarificationsList: async function () {
        const model = {
          lotId: this.lot.lotId,
          lotType: this.lot.lotType
        }
        try {
          this.isLoading = true
          await this.getClarificationsListAction(model)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
